import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { mappingResultError, Result } from '@digibricks/domains';
import { UpdateQuestionUseCase } from './update-question.usecase';
export var UPDATE_MATCHING_QUESTION_USE_CASE = 'UPDATE_MATCHING_QUESTION_USE_CASE';
export var UpdateMatchingQuestionUseCase = /*#__PURE__*/function (_UpdateQuestionUseCas) {
  _inherits(UpdateMatchingQuestionUseCase, _UpdateQuestionUseCas);

  var _super = _createSuper(UpdateMatchingQuestionUseCase);

  function UpdateMatchingQuestionUseCase() {
    _classCallCheck(this, UpdateMatchingQuestionUseCase);

    return _super.apply(this, arguments);
  }

  _createClass(UpdateMatchingQuestionUseCase, [{
    key: "updateExtendedQuestion",
    value: function updateExtendedQuestion(input) {
      var updatingPayload = input.data,
          currentQuestion = input.currentQuestion;
      var answers = updatingPayload.answers,
          correctAnswers = updatingPayload.correctAnswers,
          subQuestions = updatingPayload.subQuestions;
      var matchingQuestion = currentQuestion;
      var updatedResults = [];

      if (answers) {
        updatedResults.push(matchingQuestion.updateAnswers(answers));
      }

      if (correctAnswers) {
        updatedResults.push(matchingQuestion.updateCorrectAnswers(correctAnswers));
      }

      if (subQuestions) {
        updatedResults.push(matchingQuestion.updateSubQuestions(subQuestions));
      }

      var resultCombine = Result.combine(updatedResults);

      if (resultCombine.isFailure) {
        return mappingResultError(resultCombine);
      }

      return Result.ok(matchingQuestion);
    }
  }]);

  return UpdateMatchingQuestionUseCase;
}(UpdateQuestionUseCase);